/**
 * Recurso de tradução para permissões
 */

import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { permissionsTranslationRef } from './permissions';

export const permissionsTranslations = createTranslationResource({
  ref: permissionsTranslationRef,
  translations: {
    'pt-BR': () => import('./permissions-pt-BR'),
  },
});
